import { render, staticRenderFns } from "./TraceyPageChat.vue?vue&type=template&id=2a1f74c0&scoped=true"
import script from "./TraceyPageChat.vue?vue&type=script&lang=js"
export * from "./TraceyPageChat.vue?vue&type=script&lang=js"
import style0 from "./TraceyPageChat.vue?vue&type=style&index=0&id=2a1f74c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f74c0",
  null
  
)

export default component.exports